module.exports = __webpack_public_path__ + "img/icon-slot-yellow.ac173e6b.svg";